export const SUBMISSION_EMAIL = "qw-submissions-internal@quotewell.com";
export const SUBMISSIONS_EMAIL_NAME = "Submissions Inbox";
